import React from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon } from 'lucide-react';
type Variant = 'ember' | 'ink' | 'light' | 'outline';
type Size = 'sm' | 'md' | 'lg';
interface PlusButtonProps {
  children: React.ReactNode;
  variant?: Variant;
  size?: Size;
  to?: string;
  href?: string;
  type?: 'button' | 'submit';
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}
const variantClasses: Record<Variant, string> = {
  ember: 'bg-ember text-white hover:bg-ember-dark',
  ink: 'bg-ink text-white hover:bg-night-soft',
  light: 'bg-paper text-ink hover:bg-canvas',
  outline: 'border border-white/30 text-white hover:bg-white/10'
};
const sizeClasses: Record<Size, string> = {
  sm: 'pl-4 pr-8 py-2.5 text-sm',
  md: 'pl-5 pr-10 py-3.5 text-base',
  lg: 'pl-6 pr-11 py-4 text-[17px]'
};
export function PlusButton({
  children,
  variant = 'ember',
  size = 'md',
  to,
  href,
  type = 'button',
  onClick,
  disabled,
  className = ''
}: PlusButtonProps) {
  const classes = `group relative inline-flex items-center gap-2 whitespace-nowrap font-medium transition-colors duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ember disabled:cursor-not-allowed disabled:opacity-70 ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;
  const content = <>
      {children}
      <PlusIcon aria-hidden className="absolute right-1.5 top-1.5 h-3.5 w-3.5 transition-transform duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] group-hover:rotate-90" data-id="element-345" data-mp="1fa9lzvii1yp1" />
    </>;
  if (to) {
    return <Link to={to} className={classes} onClick={onClick} data-id="element-346" data-mp="1ozb1zlp1og30">
        {content}
      </Link>;
  }
  if (href) {
    return <a href={href} className={classes} onClick={onClick} data-id="element-347" data-mp="1k3m9g2bfzzg7">
        {content}
      </a>;
  }
  return <button type={type} className={classes} onClick={onClick} disabled={disabled} data-id="element-348" data-mp="1xyy2m59y9hv0">
      {content}
    </button>;
}